<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap v-if="initStatus === 1">
      <v-flex xs12>
        <v-stepper :value="quoteLifeCycle" class="quoteLifeCycle">
          <v-stepper-header>
            <v-stepper-step step="1" :complete="quoteLifeCycle > 1">General</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="2" :complete="quoteLifeCycle > 2">Plans</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="3" :complete="quoteLifeCycle > 3">Applicant/Risk Details</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="4" :complete="quoteLifeCycle > 4">Premium Summary</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="5" :complete="quoteLifeCycle > 5">Payment</v-stepper-step>
          </v-stepper-header>
        </v-stepper>
      </v-flex>
      <v-flex :lg8="!minimized" :lg12="minimized" xs12 :order-lg1="!minimized" :order-lg2="minimized" order-xs2>
        <transition name="slide-x-transition" mode="out-in">
          <router-view></router-view>
        </transition>
        <!-- The following dialog will work with leaveQuote Mixin (individual module to follow this structure:: just change the title) -->
        <promptLeave title="Maid" v-model="promptLeave" @exit="doExit" @saveAndExit="doSaveAndExit"></promptLeave>
      </v-flex>
      <v-flex :lg4="!minimized" :lg12="minimized" xs12 :order-lg2="!minimized" :order-lg1="minimized" order-xs1>
        <maid-quick-info v-model="minimized"></maid-quick-info>
      </v-flex>
    </v-layout>
    <loader v-else :card="false" :height="425" :init="doInit" loadText="Loading Maid Quotation Details..." errorText="Failed to load Maid Quotation Details" :loading="initStatus === 0"></loader>
  </v-container>
</template>

<script>
import PromptLeave from '../../shared/leaveQuote/PromptLeave'
import { leaveQuote } from '../../shared/leaveQuote'
import MaidQuickInfo from './MaidQuickInfo'

export default {
  data() {
    return {
      // An incomplete experiment on UI
      minimized: false
    }
  },
  computed: {
    initStatus() {
      return this.$store.state.agency.quotation.init
    },
    quoteLifeCycle() {
      return this.$store.state.agency.quotation.quoteLifeCycle
    }
  },
  methods: {
    doInit() {
      this.$store.dispatch('maidQuoteInit')
    }
  },
  mounted() {
    if (this.initStatus !== 1) {
      this.doInit()
    }
  },
  components: {
    PromptLeave,
    MaidQuickInfo
  },
  mixins: [
    leaveQuote
  ]
}
</script>

<style lang="scss">
</style>
